import { EpimsBaseEntityDto } from './epim-base.dto';

export class PurposeDto extends EpimsBaseEntityDto {

    PurposeId: string;

    PurposeName: string;
    SubscriberId: string;
    SubscriptionUserId: string;
}